import axios from "axios";

// In-memory unlock tokens per locked mailbox (cleared on reload / after 10 minutes).
const tokens = {};
export const setMailboxToken = (address, token, ttl = 600) => { tokens[address] = { token, exp: Date.now() + ttl * 1000 - 5000 }; };
export const hasMailboxToken = (address) => !!tokens[address] && tokens[address].exp > Date.now();
export const clearMailboxToken = (address) => { delete tokens[address]; };

const mailboxOf = (cfg) => {
  if (cfg.params?.mailbox) return cfg.params.mailbox;
  if (typeof FormData !== "undefined" && cfg.data instanceof FormData) return cfg.data.get("mailbox") || "";
  if (cfg.data && typeof cfg.data === "object") return cfg.data.mailbox || "";
  if (typeof cfg.data === "string") { try { return JSON.parse(cfg.data).mailbox || ""; } catch { return ""; } }
  return "";
};

axios.interceptors.request.use((cfg) => {
  if ((cfg.url || "").includes("/api/outlook/")) {
    const mb = String(mailboxOf(cfg) || "").toLowerCase();
    if (mb && hasMailboxToken(mb)) cfg.headers = { ...cfg.headers, "X-Mailbox-Token": tokens[mb].token };
  }
  return cfg;
});
